<template>
  <Block type="webLogin" class="bg webStoreBg">
    <div class="content">
      <Block type="loginBox" class="content-box">
        <span class="back j-click-vip-back" @click="backToHome">
          < {{ letter.backToPay }}
        </span>
        <Block type="gameSelectBoxStore" class="step-box">
          <p class="pay-title">{{ letter.vipTitle }}</p>
          <div class="vip-info">
            <p>
              {{ letter.nowLevel
              }}<span class="vip-level"> VIP {{ vipLevel }}</span>
            </p>
            <p>
              {{ letter.myVipScore
              }}<span class="vip-sum">{{ vipSumPoint }}</span>
            </p>
            <p v-if="+vipNextLevelPoint !== 0">
              {{
                letter.nextLevelNeed
                  .replace('${num}', vipNextLevelPoint - vipSumPoint)
                  .replace('${level}', vipLevel + 1)
              }}
            </p>
          </div>
          <div
            class="couponBtn j-click-vip-my-coupon"
            @click="refreshGameCoupon"
          >
            {{ letter.couponMyQuan }}
          </div>
          <div class="rule-content">
            <p
              class="part-1 text"
              v-for="(item, index) in ruleConfig.ruleNum"
              :key="index"
            >
              {{
                letter[gamePrefix + 'VipRule' + item].replaceAll(
                  '${gameName}',
                  gameName
                )
              }}
            </p>
            <table class="vip-desc-table" aria-describedby="vipPointDesc">
              <tr>
                <th>{{ letter.vipLevel }}</th>
                <th>{{ letter.vipCondition }}</th>
                <th>{{ letter.firstSend }}</th>
                <th>{{ letter.weeklySend }}</th>
              </tr>
              <tbody>
                <tr v-for="(item, index) in tableList" :key="index">
                  <td>VIP {{ index + 1 }}</td>
                  <td>{{ item[0] }}</td>
                  <td>{{ item[1] }}</td>
                  <td>{{ item[2] }}</td>
                </tr>
              </tbody>
            </table>
            <p class="part3 text"></p>
            <div class="ratioBtn j-click-vip-ratio" @click="jumpLink">
              {{ letter.couponRatio }}
            </div>
          </div>
        </Block>
      </Block>
    </div>
    <transition name="fade" mode="out-in">
      <coupon-list-popup
        v-if="isShowGameCouponPopup"
        popupType="game"
        :enableCouponList="gameCouponEnableList"
        :disableCouponList="gameCouponDisableList"
        :expireCouponList="gameCouponExpireList"
        :activeId="gameActiveCouponId"
        :showItemUseBtn="isShowGameItemUseBtn"
        @closeCouponPopup="hideGameCouponPopup"
        :languages="letter"
      ></coupon-list-popup>
    </transition>
  </Block>
</template>

<script>
import CouponListPopup from '../../components/webStore/CouponListPopup.vue';
import webStoreCoupon from '@mixins/webStoreCoupon';
import { couponConfig } from '../../store/config/coupon';
export default {
  name: 'VipPage',
  mixins: [webStoreCoupon],
  activated() {
    this.checkGame();
  },
  // created() {
  //   this.loadVipCouponInfo();
  //   this.loadGameCouponList();
  // },
  computed: {
    gameId() {
      return this.$store.state.gameId;
    },
    gamePrefix() {
      return this.ruleConfig.gamePrefix || '';
    },
    ruleConfig() {
      if (
        couponConfig[+this.gameId] &&
        couponConfig[+this.gameId].isVipScore &&
        couponConfig[+this.gameId].vipRuleConfig
      ) {
        return couponConfig[+this.gameId].vipRuleConfig;
      } else {
        return {};
      }
    },
    gameName() {
      return this.ruleConfig.gameName || '';
    },
    tableList() {
      if (!this.ruleConfig.table) {
        return [];
      }
      const reg = /\$\{(.+?)\}/;
      const reg_g = /\$\{(.+?)\}/g;
      return this.ruleConfig.table.map(item => {
        let itemToStr = item.join('---');
        let matchArr = itemToStr.match(reg_g);
        matchArr.forEach(target => {
          itemToStr = itemToStr.replaceAll(
            target.toString(),
            this.letter[target.match(reg)[1]]
          );
        });
        return itemToStr.split('---');
      });
    }
  },
  methods: {
    checkGame() {
      if (!this.hasVip) {
        this.backToHome();
      }
    },
    backToHome() {
      this.$router.push({
        path: '/'
      });
    },
    jumpLink() {
      window.open(this.ruleConfig.link, '_blank');
    }
  },
  components: {
    CouponListPopup
  }
};
</script>

<style lang="scss" scoped>
.bg {
  display: block;
  float: left;
  position: relative;
  width: 100%;
  height: auto;
  min-height: 100%;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  text-align: center;
}
.content {
  position: relative;
  margin: 0;
  background-color: #fff;
}
.vip-info {
  margin-bottom: 20px;
  line-height: 40px;
  font-size: 25px;
  color: #000;
  p {
    text-align: center;
  }
  .vip-level {
    font-size: 30px;
    color: #ffa200;
  }
}

.content-box {
  position: relative;
  box-sizing: border-box;
  margin: 20px auto;
  max-width: 1200px;
  font-size: 0;
  display: inline-block;
  margin: 10.7vh auto 6vh;
  background: #fff;
  text-align: center;
  padding: 3.6vh 2vh 3vh;
  .step-box {
    background: #fff;
    margin-bottom: 20px;
  }
  .back {
    position: absolute;
    left: 20px;
    height: 30px;
    cursor: pointer;
    font-size: 30px;
  }
  .pay-title {
    margin: 80px 0 20px;
    text-align: center;
    font-weight: 600;
    font-size: 60px;
    color: #000;
  }
  .couponBtn {
    display: flex;
    height: 70px;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    width: 80%;
    font-size: 30px;
    padding: 0 20px;
    color: #fff;
    background: #5fd193;
    border: 1px solid #5fd193;
    cursor: pointer;
    &:hover {
      color: #5fd193;
      background: #fff;
    }
  }
  .ratioBtn {
    color: #7a7a7a;
    cursor: pointer;
    font-size: 18px;
    text-decoration: underline;
  }
  .rule-content {
    box-sizing: border-box;
    margin-top: 30px;
    padding: 40px 30px;
    background-color: #f3f3f3;
    p {
      line-height: 40px;
      text-align: left;
      font-size: 18px;
    }
    .mt {
      margin-top: 50px;
    }
  }
  .vip-desc-table {
    border-collapse: collapse;
    border-spacing: 0;
    margin: 10px * 2 auto 30px;
    width: 96%;
    th,
    td {
      border: 1px solid #000;
      height: 41px;
      line-height: 41px;
      text-align: center;
      font-size: 20px;
      color: #000;
      white-space: pre-wrap;
      font-weight: unset;
    }
  }
}

.is-blancozone {
  .pay-title {
    color: #707070;
  }
  .vip-info {
    color: #707070;
  }
  .rule-content {
    background-color: #e9f4ff;
    border-radius: 10px;
  }
  .content-box .couponBtn {
    color: #fff;
    background: #a0caf5;
    border: 1px solid #a0caf5;
    border-radius: 10px;
  }
  .back {
    color: #707070;
  }
}
</style>